/**
 * Regra do dobro do GMR, espelhando ProcedureAuxAplicaGMR (database/procedures/campanha-apuracao.sql):
 *
 *   IF v_percentual_dobro > 0 AND v_crescimento_gmr >= v_percentual_dobro THEN
 *       v_bonus_pagamento := v_bonus_pagamento * 2;
 *
 * O que dobra o bonus e o crescimento APURADO contra o percentual de dobro --
 * nao o percentual_gmr, que e apenas o minimo para liberar o bonus.
 *
 * O parseFloat e obrigatorio: a API devolve NUMBER do Oracle como string e a
 * comparacao direta seria lexicografica ("8.76" >= "10" da verdadeiro).
 */
export default function dobrouGmr(crescimentoGmr, percentualDobro) {
  const crescimento = parseFloat(crescimentoGmr);
  const dobro       = parseFloat(percentualDobro);
  if (isNaN(crescimento) || isNaN(dobro) || dobro <= 0) return false;
  return crescimento >= dobro;
}
